// Copyright (c) 2016 Deere & Company

import ProductSearchResult, {getDefaultState} from '@deere/cps-it.warranty-model-factory/lib/product-search-results';
import actions from '../../actions-list';

const updateProduct = (state, action) =>
    ProductSearchResult.update(state, {
        $set: action.product
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_PRODUCT_SEARCH_PRODUCT]: updateProduct
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/product/search/reducers/product.js